import { z } from 'zod'

export const youTubeGamesResponseBody = z.array(z.object({ name: z.string() }))

export type YouTubeGamesResponseBody = z.infer<typeof youTubeGamesResponseBody>
